import { MapGroupId } from "../../types";
import img from "../../mapImages/GroundZeroMainwebp.webp";

const mapData = {
  groupId: MapGroupId.GroundZero,
  groupName: {
    en: "Ground Zero",
    ru: "Граунд Зиро",
  },
  title: {
    en: "Main",
    ru: "Главная",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
